import { queryOptions } from '@tanstack/react-query';
import { WalletPeriodsQueryParamsType } from './walletPeriodsQuery.type';
import { walletPeriodsFunction } from './walletPeriodsQueryFunction';

export const walletPeriodsQueryOptions = (
  params: WalletPeriodsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['wallet-periods', params],
    queryFn: () => walletPeriodsFunction(params),
  });
};
